<template>
  <div v-show="enableFiltersWrap" class="d-print-none">
    <v-card elevation="0" tile class="pt-2">
      <v-container class="py-0 px-1">
        <v-form ref="form">
          <div>
            <div v-show="enableRange">
              <div class="d-flex overline justify-start align-center px-3">
                <v-icon class="grey--text" x-small>mdi-calendar</v-icon>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  {{ $t("dateRange") }}
                </div>
                <v-divider class="ml-4"></v-divider>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  <Gmt />
                </div>
              </div>
              <Range />
            </div>

            <div
              v-if="showFiltersLine"
              class="d-flex overline justify-start align-center px-3"
            >
              <!-- <v-divider class="mr-4"></v-divider> -->
              <v-icon class="grey--text" x-small>mdi-filter</v-icon>
              <div class="pl-2 grey--text" style="font-size: 10px">
                {{ $t("filters") }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>

            <!-- Wrap -->
            <div
              class="d-flex filters-wraps"
              :class="
                $vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'
              "
            >
              <!-- Autocomplete Regionals -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteRegionals"
              >
                <AutocompleteRegionals />
              </div>

              <!-- Autocomplete Routes -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteRoutes"
              >
                <AutocompleteRoutes />
              </div>

              <!-- Autocomplete Collectors -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteCollectors"
              >
                <AutocompleteCollectors />
              </div>

              <!-- Autocomplete Locals -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteLocals"
              >
                <AutocompleteLocals />
              </div>

              <!-- Autocomplete Agents -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteAgents"
              >
                <AutocompleteAgents />
              </div>

              <!-- Autocomplete Players -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompletePlayers"
              >
                <AutocompletePlayers />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enableEventNumber">
                <EventNumber />
              </div>

              <!-- Select Result Bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectResultBet">
                <SelectResultBet />
              </div>

              <!-- Select Casino Group By -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectCasinoGroupBy"
              >
                <SelectCasinoGroupBy />
              </div>

              <!-- Sinal (Filtro de valores baseado em "igual", "maior" ou "menor") 
            Para exemplo de uso verificar "Apostas Online" -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSinal">
                <Sinal />
              </div>

              <!-- Sinal (Filtro de valores baseado em "igual", "maior" ou "menor") 
            Para exemplo de uso verificar "Apostas Online" -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSinalAward">
                <SinalAward />
              </div>

              <!-- Select Status Events (Ativos 1, Cancelados 2, Adiados 3, Suspendidos 4)  -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectStatusEvents"
              >
                <SelectStatusEvents />
              </div>

              <!-- Group Status (0 cancelado, 1 ativo)  -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGroupStatus">
                <GroupStatus />
              </div>

              <!-- Select Status Bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectStatusBet">
                <SelectStatusBet />
              </div>
              <!-- Select Event Stage -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectEventStage"
              >
                <SelectEventStage />
              </div>

              <!-- Select Type Bet (Depósito = "deposit" | Bônus = "bonus") -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectTypeBet">
                <SelectTypeBet />
              </div>

              <!-- Group Origin Bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGroupOriginBet">
                <GroupOriginBet />
              </div>

              <!-- Select Financial Category Agente -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectFinancialCategoryAgent"
              >
                <SelectFinancialCategoryAgent />
              </div>

              <!-- Type Geral or Live -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGroupTypeLive">
                <GroupTypeLive />
              </div>

              <!-- Text Quantity Bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableQuantityBet">
                <TextQuantityBet />
              </div>

              <!-- Select Type Bank Statement -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectTypeBankStatement"
              >
                <SelectTypeBankStatement />
              </div>

              <!-- Filtra o tipo de operação que volta em Bônus e Promoções -> Bônus -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableBonusReportType">
                <BonusReportType />
              </div>

              <div class="flex-grow-1 mx-2 pb-3" v-show="enablePaymentMonth">
                <PaymentMonth />
              </div>

              <!-- SinalDeposit (Filtro de valores baseado em "igual", "maior" ou "menor") 
            Para exemplo de uso verificar "Apostas Online" -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSinalDeposit">
                <SinalDeposit />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enableDepositValue">
                <DepositValue />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectSport">
                <SelectSport />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enablePaymentProvider">
                <PaymentProvider />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enableGamingType">
                <GamingType />
              </div>

              <div class="flex-grow-1 mx-2 pb-3" v-show="enableHasInvoice">
                <HasInvoice />
              </div>

              <!-- Select Status (1 Ativo, 2 Pendente, 0 Inativo)  -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectStatus">
                <SelectStatus />
              </div>

              <!-- Select Status Players -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectStatusPlayers"
              >
                <SelectStatusPlayers />
              </div>

              <!-- Select User Log Level -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectUserLogLevel"
              >
                <SelectUserLogLevel />
              </div>

              <!-- Select Action Log -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectActionLog">
                <SelectActionLog />
              </div>
              <!-- Input String -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableInputStringLog">
                <InputStringLog />
              </div>

              <!-- Select Casino Type  -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectCasinoLobby"
              >
                <SelectCasinoLobby />
              </div>

              <!-- Autocomplete Providers By Operator -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteProvidersByOperator"
              >
                <AutocompleteProvidersByOperator />
              </div>

              <!-- Select Casino Vertical Category  -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectCasinoVerticalCategory"
              >
                <SelectCasinoVerticalCategory />
              </div>

              <!-- Autocomplete Casino Categories -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteCasinoCategories"
              >
                <AutocompleteCasinoCategories />
              </div>

              <!-- Select Casino Theme  -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableSelectCasinoTheme"
              >
                <SelectCasinoTheme />
              </div>

              <!-- Select Type Bet Casino (0 apostas válidas | 1 apostas isentas) -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectTypeBetCasino">
                <SelectTypeBetCasino />
              </div>

              <!-- SEMPRE NO FINAL O EXPORTADOR DE RELATÓRIO -->
              <!-- Group Export (Site, Excel) -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGroupExport">
                <GroupExport />
              </div>
            </div>
            <!-- / Wrap Bets -->

            <!-- <v-divider class="mx-2"></v-divider> -->
            <!-- hideButtons para a view listPromotionOnline -->
            <div v-show="!hideButtons">
              <v-card-actions class="pb-3">
                <v-divider class="mr-4"></v-divider>
                <!-- <v-spacer></v-spacer> -->
                <v-btn
                  v-if="!hideClearButton"
                  class="mr-1 white black--text"
                  small
                  @click="reset()"
                  :disabled="disabledSave"
                >
                  {{ $t("toClean") }}
                </v-btn>
                <v-btn
                  class="info"
                  small
                  @click="save()"
                  :disabled="disabledSave"
                >
                  <v-icon v-if="handleFilterButtonTxt" small left>mdi-download</v-icon>
                  <v-icon v-else small left>mdi-filter</v-icon>
                  {{ handleFilterButtonTxt ? $t("download") : $t("toFilter") }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>
        </v-form>
      </v-container>
    </v-card>
    <v-divider></v-divider>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Range from "./Range";
import AutocompleteRegionals from "./AutocompleteRegionals";
import AutocompleteLocals from "./AutocompleteLocals";
import AutocompleteAgents from "./AutocompleteAgents";
import AutocompletePlayers from "./AutocompletePlayers";
import AutocompleteProvidersByOperator from "./AutocompleteProvidersByOperator";
import AutocompleteCasinoCategories from "./AutocompleteCasinoCategories";
import AutocompleteCollectors from "./AutocompleteCollectors";
import AutocompleteRoutes from "./AutocompleteRoutes";
import SelectStatus from "./SelectStatus";
import SelectCasinoLobby from "./SelectCasinoLobby";
import SelectCasinoTheme from "./SelectCasinoTheme";
import SelectCasinoVerticalCategory from "./SelectCasinoVerticalCategory";
import GroupStatus from "./GroupStatus";
import SelectStatusEvents from "./SelectStatusEvents";
import SelectStatusBet from "./SelectStatusBet";
import SelectEventStage from "./SelectEventStage";
import SelectTypeBet from "./SelectTypeBet";
import SelectTypeBetCasino from "./SelectTypeBetCasino";
import SelectResultBet from "./SelectResultBet";
import SelectCasinoGroupBy from "./SelectCasinoGroupBy";
import Sinal from "./Sinal";
import SinalDeposit from "./SinalDeposit";
import SinalAward from "./SinalAward";
import GroupOriginBet from "./GroupOriginBet.vue";
import SelectFinancialCategoryAgent from "./SelectFinancialCategoryAgent";
import GroupTypeLive from "./GroupTypeLive.vue";
import GroupExport from "./GroupExport.vue";
import TextQuantityBet from "./TextQuantityBet.vue";
import SelectTypeBankStatement from "./SelectTypeBankStatement.vue";
import SelectUserLogLevel from "./SelectUserLogLevel.vue";
import SelectActionLog from "./SelectActionLog.vue";
import InputStringLog from "./InputStringLog.vue";
import SelectStatusPlayers from "./SelectStatusPlayers.vue";
import Gmt from "../../gmt";
import EventNumber from "./EventNumber.vue";
import DepositValue from "./DepositValue.vue";
import SelectSport from "./SelectSport.vue";
import PaymentProvider from "./PaymentProvider.vue";
import GamingType from "./SelectGamingType.vue";
import BonusReportType from "./SelectBonusReportType.vue";
import PaymentMonth from "./PaymentMonth.vue";
import HasInvoice from "./HasInvoice.vue";

export default {
  name: "components-common-filter",
  components: {
    Range,
    AutocompleteRegionals,
    AutocompleteLocals,
    AutocompleteAgents,
    AutocompletePlayers,
    AutocompleteProvidersByOperator,
    AutocompleteCasinoCategories,
    AutocompleteCollectors,
    AutocompleteRoutes,
    SelectStatus,
    SelectCasinoLobby,
    SelectCasinoTheme,
    SelectCasinoVerticalCategory,
    GroupStatus,
    SelectStatusBet,
    SelectEventStage,
    SelectStatusEvents,
    SelectResultBet,
    SelectCasinoGroupBy,
    SelectTypeBet,
    SelectTypeBetCasino,
    Sinal,
    SinalDeposit,
    SinalAward,
    GroupOriginBet,
    SelectFinancialCategoryAgent,
    GroupTypeLive,
    GroupExport,
    TextQuantityBet,
    SelectTypeBankStatement,
    SelectUserLogLevel,
    SelectActionLog,
    InputStringLog,
    SelectStatusPlayers,
    Gmt,
    EventNumber,
    DepositValue,
    SelectSport,
    PaymentProvider,
    GamingType,
    BonusReportType,
    PaymentMonth,
    HasInvoice,
  },
  data: () => ({
    showFiltersLine: true,
  }),
  computed: mapState({
    exportDocStatus() {
      return this.$store.state.filters.groupExport.value
    },

    handleFilterButtonTxt() {
      const names = [
        "AdministratorReportsUsers",
        "AdministratorReportsSportBets",
        "AdministratorReportsDeposits",
        "AdministratorReportsWithdrawals",
        "AdministratorReportsCasinoBets",
        "ColabReportsUsers",
        "ColabReportsSportBets",
        "ColabReportsDeposits",
        "ColabReportsWithdrawals",
        "ColabReportsCasinoBets"
      ];

      let routeName;

      names.forEach((name) => {
        if (this.$route.name.includes(name)) {
          return routeName = name;
        }
      });

      return this.$route.name === routeName && this.exportDocStatus != "";
    },

    hideClearButton() {
      const paths = [
        "/reports/reportUsers",
        "/reports/reportSportBets",
        "/reports/reportDeposits",
        "/reports/reportWithdrawals",
        "/reports/reportCasinoBets"
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;      
    },

    hideButtons() {
      // Essas views controlam os requests internamente e não precisam do botão saveFilters
      const paths = [
        "bonusAndPromotions/listPromotionOnline",
        "bonusAndPromotions/freespins",
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;
    },

    enableFiltersWrap() {
      return this.$store.state.filters.enableWrap;
    },
    enableRange() {
      return this.$store.state.range.enable;
    },
    enableAutocompleteRegionals() {
      return this.$store.state.filters.autocompleteRegionals.enable;
    },
    enableAutocompleteLocals() {
      return this.$store.state.filters.autocompleteLocals.enable;
    },
    enableAutocompleteAgents() {
      return this.$store.state.filters.autocompleteAgents.enable;
    },
    enableAutocompletePlayers() {
      return this.$store.state.filters.autocompletePlayers.enable;
    },
    enableAutocompleteProvidersByOperator() {
      return this.$store.state.filters.autocompleteProvidersByOperator.enable;
    },
    enableAutocompleteCasinoCategories() {
      return this.$store.state.filters.autocompleteCasinoCategories.enable;
    },
    enableAutocompleteCollectors() {
      return this.$store.state.filters.autocompleteCollectors.enable;
    },
    enableAutocompleteRoutes() {
      return this.$store.state.filters.autocompleteRoutes.enable;
    },
    enableSelectStatus() {
      return this.$store.state.filters.selectStatus.enable;
    },
    enableSelectCasinoLobby() {
      return this.$store.state.filters.selectCasinoLobby.enable;
    },
    enableSelectCasinoTheme() {
      return this.$store.state.filters.selectCasinoTheme.enable;
    },
    enableSelectCasinoVerticalCategory() {
      return this.$store.state.filters.selectCasinoVerticalCategory.enable;
    },
    enableGroupStatus() {
      return this.$store.state.filters.groupStatus.enable;
    },
    enableSelectStatusEvents() {
      return this.$store.state.filters.selectStatusEvents.enable;
    },
    enableSelectStatusBet() {
      return this.$store.state.filters.selectStatusBet.enable;
    },
    enableSelectEventStage() {
      return this.$store.state.filters.selectEventStage.enable;
    },
    enableSelectTypeBet() {
      return this.$store.state.filters.selectTypeBet.enable;
    },
    enableSelectTypeBetCasino() {
      return this.$store.state.filters.selectTypeBetCasino.enable;
    },
    enableSelectResultBet() {
      return this.$store.state.filters.selectResultBet.enable;
    },
    enableSelectCasinoGroupBy() {
      return this.$store.state.filters.selectCasinoGroupBy.enable;
    },
    enableSelectFinancialCategoryAgent() {
      return this.$store.state.filters.selectFinancialCategoryAgent.enable;
    },
    enableSinal() {
      return this.$store.state.filters.sinal.enable;
    },
    enableGroupOriginBet() {
      return this.$store.state.filters.groupOriginBet.enable;
    },
    enableGroupTypeLive() {
      return this.$store.state.filters.groupTypeLive.enable;
    },
    enableGroupExport() {
      return this.$store.state.filters.groupExport.enable;
    },
    enableQuantityBet() {
      return this.$store.state.filters.quantityBet.enable;
    },
    enableSelectTypeBankStatement() {
      return this.$store.state.filters.selectTypeBankStatement.enable;
    },
    enableSelectUserLogLevel() {
      return this.$store.state.filters.selectUserLogLevel.enable;
    },
    enableSelectActionLog() {
      return this.$store.state.filters.selectActionLog.enable;
    },
    enableSelectStatusPlayers() {
      return this.$store.state.filters.selectStatusPlayers.enable;
    },
    disabledSave() {
      return this.$store.state.filters.disabledSave;
    },
    enableSinalDeposit() {
      return this.$store.state.filters.sinalDeposit.enable;
    },
    enableSinalAward() {
      return this.$store.state.filters.sinalAward.enable;
    },
    enableEventNumber() {
      return this.$store.state.filters.eventNumber.enable;
    },
    enableInputStringLog() {
      return this.$store.state.filters.inputStringLog.enable;
    },
    enableDepositValue() {
      return this.$store.state.filters.depositValue.enable;
    },
    enableSelectSport() {
      return this.$store.state.filters.selectSport.enable;
    },
    enableGamingType() {
      return this.casinoEnabled && this.$store.state.filters.gamingType.enable;
    },
    casinoEnabled() {
      return (
        this.$store.state.operator.casino &&
        this.$store.state.operator.casino != "0"
      );
    },
    enablePaymentProvider() {
      return this.$store.state.filters.paymentProvider.enable;
    },
    enableBonusReportType() {
      return this.$store.state.filters.bonusReportType.enable;
    },
    enablePaymentMonth() {
      return this.$store.state.filters.paymentMonth.enable;
    },
    enableHasInvoice() {
      return this.$store.state.filters.hasInvoice.enable;
    },
  }),

  mounted() {
    this.enableFilters(this.$route);

    if (this.$route.meta.filters) {
      if (
        this.$route.meta.filters.length == 1 &&
        this.$route.meta.filters[0] == "Range"
      ) {
        if (localStorage.getItem("level") !== "administrator") {
          this.showFiltersLine = false;
        }
      }
    }

    this.hideFilterLineForCasinoRoutes();
  },
  watch: {
    casinoEnabled() {
      this.hideFilterLineForCasinoRoutes();
    },
    enablePaymentProvider(val) {
      if (!val) {
        if (this.$route.meta.filters) {
          const gatewayFilterRoutes = [
            "AdministratorAccountabilityOnlineBankStatement",
            "CollaboratorAccountabilityOnlineBankStatement",
            "BankStatementByUser",
            "CollaboratorBankStatementByUser",
            "AdministratorAccountabilityOnlineDeposits",
            "CollaboratorAccountabilityOnlineDeposits",
            "ListWithdraws",
            "CollaboratorListWithdraws",
          ];

          if (gatewayFilterRoutes.includes(this.$route.name)) {
            const paymentProviderFilter = this.$route.meta.filters.filter(
              (filter) => filter == "PaymentProvider"
            );

            if (paymentProviderFilter) {
              this.showFiltersLine = false;
            }
          }
        }
      }
    },
    $route: function(route) {
      this.enableFilters(route);

      if (!route.meta.filters) return;

      const gatewayFilterRoutes = [
        "AdministratorAccountabilityOnlineBankStatement",
        "CollaboratorAccountabilityOnlineBankStatement",
        "BankStatementByUser",
        "CollaboratorBankStatementByUser",
        "AdministratorAccountabilityOnlineDeposits",
        "CollaboratorAccountabilityOnlineDeposits",
        "ListWithdraws",
        "CollaboratorListWithdraws",
      ];

      if (gatewayFilterRoutes.includes(route.name)) {
        const paymentProviderFilter = route.meta.filters.filter(
          (filter) => filter == "PaymentProvider"
        );

        if (
          route.meta.filters.length == 1 &&
          route.meta.filters[0] == "Range"
        ) {
          if (localStorage.getItem("level") !== "administrator") {
            this.showFiltersLine = false;
          } else {
            this.showFiltersLine = true;
          }
        } else if (!this.enablePaymentProvider && paymentProviderFilter) {
          this.showFiltersLine = false;
        } else {
          this.showFiltersLine = true;
        }
      }

      this.hideFilterLineForCasinoRoutes();
    },
  },
  methods: {
    /// Set Save in store vuew;
    save() {
      // Fields Required
      // Autocomplete Regionals
      if (this.enableAutocompleteRegionals) {
        if (!this.$refs.form.validate()) {
          return;
        }
      }
      this.$store.commit("setSave", true);
      this.$store.commit("DisabledSave", true);
    },

    /// Reset Filters to Default;
    reset() {
      // Components Reset
      this.$store.commit("setRegionalId", "");
      this.$store.commit("setLocalId", "");
      this.$store.commit("setAgentId", "");
      this.$store.commit("setPlayerId", "");
      this.$store.commit("setCollectorId", "");
      this.$store.commit("setRouteId", "");
      this.$store.commit("setSelectStatus", 0);
      if (this.$route.name === "ListCategories") {
        this.$store.commit("setSelectCasinoLobby", "");
      } else {
        this.$store.commit("setSelectCasinoLobby", 0);
      }
      this.$store.commit("setProviderId", "");
      this.$store.commit("setCasinoCategoryName", "");
      this.$store.commit("setSelectCasinoTheme", "");
      this.$store.commit("setSelectCasinoVerticalCategory", "");
      this.$store.commit("setGroupStatus", 1);
      this.$store.commit("setSelectResultBet", 3);
      this.$store.commit(
        "setSelectCasinoGroupBy",
        this.$route.name == "CasinoListBetOnline" ||
          this.$route.name === "CollaboratorCasinoListBetOnline"
          ? "game"
          : "jogo"
      );
      this.$store.commit("setSelectStatusBet", 1);
      this.$store.commit("setSelectEventStage", "");
      this.$store.commit("setSelectTypeBet", "deposit");
      this.$store.commit("setSelectTypeBetCasino", 0);
      this.$store.commit("setSelectStatusEvents", 1);
      this.$store.commit("setSinal", { option: "", valor: "" });
      this.$store.commit("setSinalDeposit", { option: "", valor: "" });
      this.$store.commit("setSinalAward", { option: "", valor: "" });
      this.$store.commit("setDepositValue", { option: "", value: "" });
      this.$store.commit("setSelectSport", {
        text: this.$t("sports"),
        value: "sports",
      });
      this.$store.commit("setBonusReportType", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setGamingType", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setPaymentProvider", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setEventNumber", "");
      this.$store.commit("setGroupOriginBetValue", "todos");
      this.$store.commit("setSelectFinancialCategoryAgent", 3);
      this.$store.commit("setGroupTypeLive", "");
      this.$store.commit("setGroupExport", "");
      this.$store.commit("setSelectTypeBankStatement", "");
      this.$store.commit("setSelectUserLogLevel", "");
      this.$store.commit("setSelectActionLog", "");
      this.$store.commit("setInputStringLog", "");
      this.$store.commit("setSelectStatusPlayers", "");
      this.$store.commit("setQuantityBet", 10);
      this.$store.commit("setHasInvoice", { value: "", text: "" });

      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);

      this.$store.commit("setPaymentMonth", {
        value: (() => {
          let d = new Date(new Date().setMonth(new Date().getMonth() - 1));
          return new Date(d - d.getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 7);
        })(),
      });

      this.$store.commit("disablePaymentMonth");

      this.$nextTick(() => {
        this.$refs.form.inputs.forEach((input) => {
          if (!input.disabled) {
            input.reset();
          }
        });

        this.$store.commit("enablePaymentMonth");
      });
    },

    /// Logic Enable Filters:
    enableFilters(route) {
      // Setup Filter:
      // 'Setters' from Vuex:
      const filters = [
        "FiltersWrap",
        "Range",
        "AutocompleteRegionals",
        "AutocompleteLocals",
        "AutocompleteAgents",
        "AutocompletePlayers",
        "AutocompleteProvidersByOperator",
        "AutocompleteCasinoCategories",
        "AutocompleteCollectors",
        "AutocompleteRoutes",
        "SelectStatus",
        "SelectCasinoLobby",
        "SelectCasinoTheme",
        "SelectCasinoVerticalCategory",
        "GroupStatus",
        "SelectResultBet",
        "SelectCasinoGroupBy",
        "SelectStatusBet",
        "SelectEventStage",
        "SelectTypeBet",
        "SelectTypeBetCasino",
        "SelectStatusEvents",
        "Sinal",
        "SinalDeposit",
        "SinalAward",
        "GroupOriginBet",
        "SelectFinancialCategoryAgent",
        "GroupTypeLive",
        "GroupExport",
        "QuantityBet",
        "SelectTypeBankStatement",
        "SelectUserLogLevel",
        "SelectActionLog",
        "InputStringLog",
        "SelectStatusPlayers",
        "EventNumber",
        "DepositValue",
        "SelectSport",
        "PaymentProvider",
        "GamingType",
        "BonusReportType",
        "PaymentMonth",
        "HasInvoice",
      ];

      // 1. hide all filters
      filters.forEach((filter) => {
        this.$store.commit(filter, false);
      });

      // 2. Enable chosen filters on the route
      if (route.matched.some((record) => record.meta.filters)) {
        this.$store.commit("FiltersWrap", true);
        route.matched.forEach((record) => {
          if (record.meta.filters) {
            record.meta.filters.forEach((filter) => {
              this.$store.commit(filter, true);
            });
          }
        });
      }
    },

    hideFilterLineForCasinoRoutes() {
      const routes = [
        "AdministratorOnlineExtract",
        "RegionalManagerAffiliates",
        "Local-managerAdministratorComissionOnline",
      ];

      if (routes.includes(this.$route.name)) {
        if (this.casinoEnabled == false) {
          this.showFiltersLine = false;
        }

        if (localStorage.getItem("level") !== "administrator") {
          this.showFiltersLine = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.filters-wraps {
  flex-wrap: wrap;
}
.filters-wraps > div {
  flex-basis: 33.33333%;
}
</style>
